
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocal as ObiLocalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-local.js';
 
 
 

 
 export const ObiLocal = createComponent({
   react: React,
   tagName: 'obi-local',
   elementClass: ObiLocalElement,
   events: {
     
   }
  });
 
 